import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      padding: theme.spacing(2),
      borderRadius: 4,
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    title: {
      fontSize: 13,
      marginBottom: theme.spacing(1),
    },

    error: {
      border: 'solid 1px #ef9a9a',
      backgroundColor: '#ffebee',
    },
    errorTitle: {
      color: '#870808 !important',
    },

    info: {
      border: 'solid 1px #90caf9',
      backgroundColor: '#e3f2fd',
    },
    infoTitle: {
      color: '#003a52 !important',
    },

    disable: {
      border: 'solid 1px #cfd8dc',
      backgroundColor: '#eceff1',
    },
    disableTitle: {
      color: '#003a52 !important',
    },

    content: {
      color: '#1a334d',
    },
  };
});